 import React,{useEffect, useState} from 'react';
 import axios from 'axios'
import {useParams} from 'react-router-dom'
const Image = () => {
const {name} = useParams()
const [pokemon, setPokemon] =useState({})
const [pokemonPics, setPokemonPics]=useState([])
    useEffect(()=>{
        const fetchPokemon = async()=>{
            try{
                let poke = await axios.get(`https://pokeapi.co/api/v2/pokemon/${name}`)
                setPokemon(poke.data.types)
                setPokemonPics(poke.data.sprites)
            }catch(error){
                setPokemon({})
            }
        }
        fetchPokemon()
    },[])


    return(
        <>
        <div className="pokemonName">
{name}



        </div>
<div className="pokemonPic">
<img src={pokemonPics.front_default} alt=""></img>
<h3>

</h3>
</div>
        </>
    )       
}

export default Image;